export default __webpack_public_path__ + "static/media/logo.9a30dc9e.svg";